<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/va-number/${inputs.id}`
						: `transaction/va-number`
				"
			>
				
				<div class="form-group row align-items-center">
					<label for="inputs_bank_id" class="col-sm-3 mb-0">
						Bank Name
					</label>
					<app-input
						id="inputs_bank_id"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_bank_id"
						@input="setBankIdValue"
						fetch-url="master/bank"
						class="col-sm-9"
						placeholder="Bank Name"
						list-value-field="bank_name"
						required
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_account_number" class="col-sm-3 mb-0">
						Account Number
					</label>
					<app-input
						id="inputs_account_number"
						class="col-sm-9"
						type="text"
						v-model="inputs.account_number"
						placeholder="Account Number"
					/>
				</div>
				<div class="form-group row align-items-center">
					<div classs="col-md-12">
						<br>
					</div>
				</div>
				<div class="form-group row align-items-center">
					<div classs="col-md-12">
						<br>
					</div>
				</div>
				<div class="form-group row align-items-center">
					<div classs="col-md-12">
						<br>
					</div>
				</div>
				<div class="form-group row align-items-center">
					<div classs="col-md-12">
						<br>
					</div>
				</div>
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_attendance" class="col-sm-3 mb-0">
						Attendance
					</label>
					<app-input
						id="inputs_attendance"
						class="col-sm-9"
						type="text"
						v-model="inputs.attendance"
						placeholder="Attendance"
						:required="true"
					/>
				</div> -->
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "VaNumberTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {
				clc_id_number: this.value.clc_id_number || "",
			},
			subStatusLists: [],
			input_bank_id: this.value
				? this.value.bank
					? {
							id: this.value.bank.id || 0,
							name: this.value.bank.bank_name || "",
							is_active: this.bank.center.is_active,
					  }
					: {
							id: this.value.bank?.id || 0,
							name: this.value.bank?.bank_name || "",
							is_active: this.value.bank?.is_active,
					  }
				: {
						id: this.value.bank.id || 0,
						name: this.value.bank.bank_name || "",
						is_active: this.value.bank.is_active,
				  },
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs.id = response.data.id;
			this.inputs.bank_id = response.data.bank?.id;
			this.input_bank_id = {
				id: response.data.bank?.id,
				bank_name: response.data.bank?.bank_name,
			};
			this.inputs.account_number = response.data.account_number;
			this.preloader = false;
		},
		setBankIdValue(data) {
			this.inputs.bank_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.bank_id = data.id;
			}
		},
		
	},
};
</script>
